import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/auth/ProtectedRoute';
import ErrorBoundary from './components/ErrorBoundary';
import { EnvironmentBanner } from './components/layout/EnvironmentBanner';
import LandingPage from './pages/LandingPage';
import AboutPage from './pages/AboutPage';
import PricingPage from './pages/PricingPage';
import LoginPage from './pages/auth/LoginPage';
import RegisterPage from './pages/auth/RegisterPage';
import ForgotPasswordPage from './pages/auth/ForgotPasswordPage';
import ResetPasswordPage from './pages/auth/ResetPasswordPage';
import DashboardPage from './pages/DashboardPage';
import ProfilePage from './pages/ProfilePage';
import SchoolsPage from './pages/SchoolsPage';
import TestSentry from './components/TestSentry';
import ComingSoonPage from './pages/ComingSoonPage';
import { CookieConsentBanner } from './components/CookieConsentBanner';
import CoachDashboard from './pages/coach/CoachDashboard';
import CoachRoute from './components/auth/CoachRoute';
// Legal pages
import PrivacyPolicyPage from './pages/legal/PrivacyPolicyPage';
import TermsOfServicePage from './pages/legal/TermsOfServicePage';
import CookiePolicyPage from './pages/legal/CookiePolicyPage';
import CoppaRightsPage from './pages/legal/CoppaRightsPage';

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <AuthProvider>
          <EnvironmentBanner />
          {process.env.NODE_ENV === 'development' && <TestSentry />}
          <CookieConsentBanner />
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<ComingSoonPage />} />
            <Route path="/landing" element={<LandingPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />

            {/* Legal pages */}
            <Route path="/privacy" element={<PrivacyPolicyPage />} />
            <Route path="/terms" element={<TermsOfServicePage />} />
            <Route path="/cookies" element={<CookiePolicyPage />} />
            <Route path="/coppa-rights" element={<CoppaRightsPage />} />

            {/* Coach routes */}
            <Route
              path="/coach"
              element={
                <CoachRoute>
                  <CoachDashboard />
                </CoachRoute>
              }
            />

            {/* Protected routes */}
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <ProfilePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/schools"
              element={
                <ProtectedRoute>
                  <SchoolsPage />
                </ProtectedRoute>
              }
            />
          </Routes>
        </AuthProvider>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
